import { Tab } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { TitrePedagogiqueDetailPage } from "..";
import { TitrePedagogiqueApi } from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { BackButton, PageBase, ProtectedTabs } from "../../../../../components";
import { useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

interface ITitrePedagogiqueItemPageProps {}

export const TitrePedagogiqueItemPage: React.FunctionComponent<ITitrePedagogiqueItemPageProps> = () => {
  const { t } = useTl();
  const history = useHistory();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();

  const api = useApiService(TitrePedagogiqueApi);
  const [displayName] = useApiEffect(() => api.titrePedagogiqueGetDisplayName({ id: +id }), [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.TitresPedagogiques), route: ERoutes.titrePedagogique },
        { text: +id <= 0 ? t(ETLCodes.New) : displayName }
      ]}
    >
      <ProtectedTabs
        id="TabDetail"
        onChange={newTabId => history.push(`${ERoutes.titrePedagogique}/${id}/${newTabId}`)}
        renderActiveTabPanelOnly
        selectedTabId={tab}
      >
        <BackButton backRoute={ERoutes.titrePedagogique}></BackButton>
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<TitrePedagogiqueDetailPage idTitre={+id} editMode={state === "edit"} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
